export const REPORT_GROUPS = [
  {
    label: "Daybook",
    reports: [
      { key: "daybook", label: "Daybook" },
    ],
  },
  {
    label: "Summary Reports",
    reports: [
      { key: "sales_summary", label: "Sales Summary" },
      { key: "purchase_summary", label: "Purchase Summary" },
      { key: "expense_summary", label: "Expense Summary" },
      { key: "customer_summary", label: "Customer Summary" },
      { key: "vendor_summary", label: "Vendor Summary" },
      { key: "pl_snapshot_summary", label: "P&L Snapshot Summary" },
    ],
  },
  {
    label: "P&L",
    reports: [
      { key: "pl_statement", label: "P&L Statement" },
      { key: "sales_pl_report", label: "Sales P&L Report" },
      { key: "sale_items_pl_report", label: "Sale Items P&L Report" },
      { key: "item_wise_pl_purchases", label: "Item-wise P&L (Purchases)" },
      { key: "item_wise_pl_purchase_price", label: "Item-wise P&L Report (Purchase Price)" },
      { key: "category_wise_pl_purchase_price", label: "Category-wise P&L Report (Purchase Price)" },
      { key: "customer_wise_pl_report", label: "Customer-wise P&L Report" },
    ],
  },
];

export const REPORTS = REPORT_GROUPS.flatMap((group) =>
  group.reports.map((report) => ({ ...report, group: group.label })),
);

export const getReportByKey = (key) => REPORTS.find((report) => report.key === key);
export const reportPath = (key) => `/reports/expanded/${encodeURIComponent(key)}`;
export const getReportPath = reportPath;